import React, { useContext } from 'react'

import { Paper, styled } from '@driftt/dds'

import { AccountDrawerContext } from 'context/accountDrawerContext'
import { PresenceContext } from 'context/presenceContext'
import usePresenceStore from 'hooks/usePresenceStore'

import DrawerHeader from './DrawerHeader'

const Drawer = styled(Paper, {
  height: '100%',
  position: 'fixed',
  top: 0,
  right: 0,
  width: '50%',
  maxWidth: '720px',
  minWidth: '670px',
  transform: 'translateX(100%)',
  transition: 'transform 0.3s ease-out',
  zIndex: 1150,
  '&.open': {
    transform: 'translateX(0)'
  }
})

const AccountDrawer: React.FC = () => {
  const { isOpen, setIsOpen, accountId } = useContext(AccountDrawerContext)
  const presence = usePresenceStore()

  return (
    <PresenceContext.Provider value={presence}>
      <Drawer className={isOpen ? 'open' : ''} elevation={4}>
        {accountId ? <DrawerHeader accountId={accountId} setIsOpen={setIsOpen} /> : null}
      </Drawer>
    </PresenceContext.Provider>
  )
}

export default AccountDrawer
